<template>
  <ui-fake-scroll-box ref="scrollBox"
                      @onScroll="onScroll">
    <ul :class="`${ 'mode-' + mode }`">
      <li v-for="(item) in listDataArray"
          :key="item._id"
          :class="{
            'bookmarked': item.bookmark || isCustomNode,
            'selected': selectedId === item._id,
            'is-mobile': isMobile,
            'custom': isCustomNode
          }"
          :data-id="item._id"
          @click="onItemClick">
        <div class="inwrap" :class="{'custom': isCustomNode}" :style="customNodeStyle(item)">
          <ba-node-thumbnail-slide v-if="!isCustomNode"
                                   :thumbnails="item._thumbnailsMap"
                                   :defaultThumbnails="defaultThumbnails"
                                   :initialSlide="defaultSlideIndex" />
          <strong class="title" :class="{'custom': isCustomNode}">
            <ui-center-ellipsis v-if="!isCustomNode">{{ item.title }}</ui-center-ellipsis>
            <span v-else class="customTitle">{{ item.customValue }}</span>
          </strong>
          <dl v-if="!isCustomNode">
            <dt>Domain</dt>
            <dd class="domain">
              <ui-center-ellipsis>{{ item._domain }}</ui-center-ellipsis>
            </dd>
            <dt>Path</dt>
            <dd class="path">
              <ui-center-ellipsis>{{ item._path }}</ui-center-ellipsis>
            </dd>
          </dl>
        </div>
        <p v-if="mode === 'manage'"
           class="button">
          <ui-button size="small"
                     :loading="item._loading"
                     :iconName="!item.bookmark ? 'icon--reset' : ''"
                     @click="onToggleButtonClick">
            {{ item.bookmark ? $t('bookmark.remove') : $t('common.undo') }}
          </ui-button>
        </p>
      </li>

    </ul>
  </ui-fake-scroll-box>
</template>

<script>
import browser from '@/libs/browser'

import UiButton from '@/components/ui/UiButton'
import UiFakeScrollBox from '@/components/ui/UiFakeScrollBox'
import UiCenterEllipsis from '@/components/ui/UiCenterEllipsis'

import BaNodeThumbnailSlide from '@/components/targeting/NodeThumbnailSlide'
import BaBookmarkNeedMore from '@/components/targeting/BookmarkNeedMore'

export default {
  name: 'BaBookmarkCardList',
  components: {
    UiButton,
    UiFakeScrollBox,
    UiCenterEllipsis,
    BaNodeThumbnailSlide,
    BaBookmarkNeedMore
  },
  props: {
    mode: {
      type: String,
      default: 'targeting',
      validator: (value) => {
        return ['targeting', 'manage'].indexOf(value) > -1
      }
    },
    listDataArray: {
      type: Array,
      required: true
    },
    selectedId: {
      type: [Number, String],
      required: true
    },
    defaultThumbnails: {
      type: Object,
      required: true
    },
    defaultSlideIndex: {
      type: Number,
      required: true
    },
    isCustomNode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listScrollTop: 0
    }
  },
  computed: {
    isMobile () {
      return browser.isMobile
    }
  },
  created () {
  },
  mounted () {
    requestAnimationFrame(() => {
      const $selected = this.$el.querySelector('.selected')
      if ($selected) {
        this.$refs.scrollBox.scrollTop($selected.offsetTop - 20)
      }
      this.refresh()
    })
  },
  beforeDestroy () {
  },
  methods: {
    customNodeStyle (item) {
      if (this.isCustomNode) {
        return {
          'background-color': item.customColor
        }
      } else {
        return null
      }
    },
    onItemClick (e) {
      const id = e.currentTarget.dataset.id
      this.$emit('onSelect', isNaN(id) ? id : parseInt(id))
    },
    onToggleButtonClick (e) {
      const id = e.currentTarget.parentNode.parentNode.dataset.id
      this.$emit('onToggleBookmark', isNaN(id) ? id : parseInt(id))
    },
    refresh () {
      this.$refs.scrollBox.refresh()
    },
    onScroll (scrollTop, scrollHeight, scrollableTop) {
      this.$emit('onScroll', scrollTop, scrollHeight, scrollableTop)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-fake-scroll-box /deep/ {
  .scroll-box {
    padding: 0 0 20px 10px;
    box-sizing: border-box;
  }
}
ul {
  font-size: 0;

  &.mode-targeting {
    li {
      height: 300px;

      &.custom {
        height: 207px;
        display: inline-flex;
      }

      &:not(.need-more) {
        &:before {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 18px;
          height: 18px;
          content: '';
          border: solid 2px #aaa;
          border-radius: 100%;
          box-sizing: border-box;
          background-color: #fff;
          transition: border-color 0.2s ease-out;
          z-index: 2;
        }
        &:after {
          position: absolute;
          right: 14px;
          top: 14px;
          width: 10px;
          height: 10px;
          content: '';
          border-radius: 100%;
          background-color: #ec0047;
          opacity: 0;
          transition: opacity 0.2s ease-out;
          z-index: 2;
        }
      }

      &.selected {
        &:before {
          border-color: #ec0047;
        }
        &:after {
          opacity: 1;
        }
      }
    }
  }
}
li {
  position: relative;
  width: 270px;
  height: 350px;
  font-size: 12px;
  vertical-align: top;
  margin: 20px 10px 0;
  display: inline-block;
  z-index: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &:not(.is-mobile):hover {
    .inwrap {
      box-shadow: 0 13px 12px -5px rgba(0, 0, 0, 0.25), 0 0 0 2px #0074ff;
    }
  }

  &:not(.is-mobile):not(:hover),
  &.is-mobile:not(.selected) {
     .thumbnail-slide /deep/ [class*="button-"] {
      opacity: 0;
      pointer-events: none;
    }
  }

  &.selected {
    .inwrap {
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 3px #ec0047, 0 0 0 1px rgba(0, 0, 0, 0.16) !important;
    }
  }

  &.bookmarked {
    .thumbnail-slide {
      &:after {
        opacity: 1;
      }
    }
  }

  &:not(.bookmarked) {
    .inwrap {
      opacity: 0.3;
    }
  }

  .inwrap {
    height: 100%;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 3px 4px -1px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: box-shadow 0.2s ease-out, opacity 0.2s ease-out;

    &.custom {
      width: 270px;
    }
  }

  .title {
    font-size: 15px;
    font-weight: 500;
    color: #222;
    line-height: 1;
    margin: 17px 15px 16px;
    display: block;
    &.custom {
      color: #FFF;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 24px */
      width: 200px;
    }
  }

  dl {
    margin: 0 15px;
    overflow: hidden;

    dt,
    dd {
      height: 37px;
      border-top: 1px solid #ebebeb;
    }

    dt {
      float: left;
      width: 62px;
      font-size: 12px;
      font-weight: 500;
      color: #767676;
      line-height: 37px;
    }
    dd {
      float: right;
      width: calc(100% - 62px);
      font-size: 13px;
      color: #444;
      line-height: 37px;
    }
  }

  .button {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 15px;
    text-align: center;

    button.ui-btn.size--small {
      min-width: 90px;
      font-weight: 500;
      text-align: center;
    }
  }

  .thumbnail-slide {
    &:after {
      position: absolute;
      left: 0;
      top: 0;
      width: 43px;
      height: 43px;
      content: '';
      background: url('../../assets/img/targeting/icon--bookmark-ribbon.svg') no-repeat 0 0 / 100%;
      z-index: 1;
      opacity: 0;
      transition: opacity 0.1s ease-out;
    }
  }
}

li.need-more {
  width: 560px;
  background: none;
  box-shadow: none;

  .need-more-ment {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    padding-top: 65px;
    transform: translateY(-50%);

    & /deep/ {
      .text {
        text-align: center;
        padding: 18px 0 0;
        display: block;
      }
    }
  }
}
</style>
